import { Link } from 'react-router-dom';
import { Button, Tab } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import ContactWizData from './ContactWizardData';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { useCreateAppointmentMutation, useCreateContactFromProjectMutation, useCreateContactMutation, useCreateProjectApiForStatusUpdateMutation, useGetDefaultlookupsQuery, useGetProjectLookupsQuery, useUpsertContactOpportunitiesMutation, useUpsertLeadSourceMutation } from '../../../../services/EndPointsApis';
import AddressesWizData from './AddressesWizData';
import SummaryWizardContact from './SummaryWizardContact';
import { toast } from "react-toastify";
import OpportunityDetailsContactWizard from './OpportunityDetailsContactWizard';
import AppointmentContactWizard from './AppointmentContactWizard';
import { initialValuesAppointment, initialValuesContactOppoertuityDetails, initialValuesContactWizard, initialValuesLeadSource } from './InitialValuesContactWizard';
import SourceContactWizard from './SourceContactWizard';
import NotesContactWizard from './NotesContactWizard';

const ContactWizard = ({ activityTogglePopup, AccountId, projectId, AccountName, closeSidebar, isEditing, viewOnly, refetch }: any) => {

  const steps = ['Contact', 'Addresses', 'OpportunityDetails', "Appointments", 'Source', "Notes", 'Summary'];
  const [activeStep, setActiveStep] = useState(0);
  const [toogle, setToogle] = useState(true)
  const [adressConfirm, setAdressConfirm] = useState(false)
  const [refetchOpportunityDetails, setRefetchOpportunityDetails] = useState(false)

  const [ProjectId, setProjectId] = useState("0");

  //create contact
  const [createContact, { data, isError, error, isSuccess, isLoading }] = useCreateContactFromProjectMutation();
  //upsert contact opportunity details
  const [upsertContactOpportunity, { data: contactOpportunity }] = useUpsertContactOpportunitiesMutation();
  //Api Appointment
  const [createAppointment, { data: aptData }] = useCreateAppointmentMutation();
  //Api lead Source
  const [createLeadSource, { data: leadSource }] = useUpsertLeadSourceMutation();
  //Default Lookups
  const { data: getdefaultLookups, refetch: defualtRefetch } = useGetDefaultlookupsQuery('');
  //Project Lookups
  const { data: projectLookups, refetch: projectLookupsRefetch } = useGetProjectLookupsQuery('');

  const validationSchema = Yup.object({
    primaryContact: Yup.object({
      homeEmail: Yup.string()
        .email("Invalid email format")
        .required("Home email is required")
        .matches(/.+@example\.com$/, "Work email must be @example.com"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Work email is required")
        .matches(/.+@example\.com$/, "Work email must be @example.com"),
    }),
  });
  //Formik contact
  const formik = useFormik({
    initialValues: initialValuesContactWizard,
    onSubmit: (values) => {
      createContact({ ...values });
    },
  });

  //Formik contact Opportunity

  const formikContactOpportunity = useFormik({
    // validationSchema: contactSchema,
    initialValues: initialValuesContactOppoertuityDetails,
    onSubmit: (values) => {
      upsertContactOpportunity({ ...values, projectId: data?.result });
    },
  });
  //Formik

  const formikAppointment = useFormik({
    initialValues: initialValuesAppointment,
    // validationSchema: contactSchema,
    onSubmit: (values) => {
      createAppointment({ ...values, leadInquiryId: data?.result });
    },
  });
  //Formik

  const formikSource = useFormik({
    initialValues: initialValuesLeadSource,
    // validationSchema: contactSchema,
    onSubmit: (values) => {
      createLeadSource({ ...values, projectId: data?.result });
    },
  });


  const { resetForm: resetFormSource } = formikSource;
  const { resetForm: resetFormAppointment } = formikAppointment;
  const { resetForm } = formik
  const { resetForm: resetFormOpportunity } = formikContactOpportunity

  const getContactContent = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <ContactWizData formik={formik} data={data} error={error} isError={isError} isSuccess={isSuccess} closeSidebar={closeSidebar} refetch={refetch} toogle={toogle} setToogle={setToogle} />;
      case 1:
        return <AddressesWizData formik={formik} setAdressConfirm={setAdressConfirm} adressConfirm={adressConfirm} />
      case 2:
        return <OpportunityDetailsContactWizard refetchOpportunityDetails={refetchOpportunityDetails} projectId={projectId} formik={formikContactOpportunity} projectLookups={projectLookups} />
      case 3:
        return <AppointmentContactWizard formik={formikAppointment} getdefaultLookups={getdefaultLookups} />
      case 4:
        return <SourceContactWizard formik={formikSource} getdefaultLookups={getdefaultLookups} projectLookups={projectLookups} />
      case 5:
        return <NotesContactWizard formik={formik} />
      case 6:
        return <SummaryWizardContact formik={formik} formikContactOpportunity={formikContactOpportunity} formikAppointment={formikAppointment} formikSource={formikSource} />

      default:
        return 'Unknown stepIndex';
    }
  }
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validateCurrentStep = () => {
    const { primaryContact, secondaryContact } = formik.values;

    if (activeStep === 0) {
      if (!toogle) {
        return (
          primaryContact?.contactType?.id &&
          primaryContact?.salutation?.id &&
          primaryContact?.firstName &&
          primaryContact?.lastName
        ) ? true : false;
      } else {
        return (
          secondaryContact?.contactType?.id &&
          secondaryContact?.salutation?.id &&
          secondaryContact?.firstName &&
          secondaryContact?.lastName
        ) ? true : false;
      }
    }

    if (activeStep === 1) {
      return (
        primaryContact.mailingAddress.addressLine1 &&
        primaryContact.mailingAddress.zipCode &&
        primaryContact.mailingAddress.stateName &&
        primaryContact.mailingAddress.cityName &&
        primaryContact.propertyAddress.addressLine1 &&
        primaryContact.propertyAddress.zipCode &&
        primaryContact.propertyAddress.stateName &&
        primaryContact.propertyAddress.cityName
      ) ? true : false;
    }
    if (activeStep === 2) {
      const { opportunityDetailsDescription } = formikContactOpportunity.values;
      return (
        opportunityDetailsDescription?.description &&
        opportunityDetailsDescription?.jobType?.id
      )
    }
    if (activeStep === 3) {
      const { startDate, startTime, internalAttendees, lst_FreshAptLocation } = formikAppointment.values;
      return (
        startDate &&
        startTime &&
        internalAttendees[0]?.id &&
        lst_FreshAptLocation?.id
      )
    }
    if (activeStep === 4) {
      const { firstContactDate, lst_MethodOfInquiry, lst_LeadSource } = formikSource.values;
      return (
        firstContactDate &&
        lst_MethodOfInquiry?.id &&
        lst_LeadSource?.id
      )
    }
    if (activeStep === 5) {
      const { internalComments } = formik.values;
      return (
        internalComments
      )
    }
    return true;
  };

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      formik.handleSubmit()
    }
    if (activeStep === 2) {
      setRefetchOpportunityDetails(true)
    }


    // if (activeStep === 0 && !toogle) {
    //   const workEmail = formik.values.primaryContact?.workEmail?.trim() ?? "";
    //   const homeEmail = formik.values.primaryContact?.homeEmail?.trim() ?? "";

    //   if (workEmail && !emailRegex.test(workEmail)) {
    //     toast.error("Invalid primaryContact work email format");
    //     return false;
    //   }
    //   if (homeEmail && !emailRegex.test(homeEmail)) {
    //     toast.error("Invalid primaryContact home email format");
    //     return false;
    //   }

    //   return true;
    // }

    // if (activeStep === 0 && toogle) {
    //   const workEmail = formik.values.secondaryContact?.workEmail?.trim() ?? "";
    //   const homeEmail = formik.values.secondaryContact?.homeEmail?.trim() ?? "";

    //   if (workEmail && !emailRegex.test(workEmail)) {
    //     toast.error("Invalid secondaryContact work email format");
    //     return false;
    //   }
    //   if (homeEmail && !emailRegex.test(homeEmail)) {
    //     toast.error("Invalid secondaryContact home email format");
    //     return false;
    //   }

    //   return true;
    // }

  };

  useEffect(() => {
    if (isSuccess) {
      formikContactOpportunity.handleSubmit()
      formikAppointment.handleSubmit()
      formikSource.handleSubmit()
    }
  }, [isSuccess])

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };


  useEffect(() => {
    if (closeSidebar) {
      setActiveStep(0)
      setAdressConfirm(false)
      setTimeout(() => {
        resetFormOpportunity()
        resetFormAppointment()
        resetFormSource()
      }, 5000);
      setTimeout(() => {
        resetForm();
      }, 1000);
      setProjectId("0")
      setRefetchOpportunityDetails(false)
    }
  }, [closeSidebar])

  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.message);
      setProjectId(data?.result)
      closeSidebar();
      setTimeout(() => {
        resetForm();
        resetFormOpportunity()
        resetFormAppointment()
        resetFormSource()
      }, 5000);
      refetch()
      // refetchContacts()
    }

  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);

  const isNextDisabled = !validateCurrentStep() || isLoading;

  return (
    <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
      <div className="sidebar-layout custom-wizard">
        <div className='d-flex justify-content-end me-2'>
          <button className="sidebar-close close-btn-Wizard " onClick={closeSidebar}>
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="sidebar-header p-2">
          <h4>Contact Wizard</h4>
          <div className='d-flex gap-2'>
            <div className="submit-button text-end">
              <button
                className="btn btn-light"
                disabled={activeStep === 0}
                onClick={handleBack}
              >
                Back
              </button>
              <button
                className='btn btn-primary'
                onClick={handleNext}
                disabled={!validateCurrentStep() || isLoading}
              >

                {activeStep === steps.length - 1 ? 'Save' : 'Next'}
              </button>
            </div>

          </div>
        </div>
        <div className="toggle-body toggled-body">
          <div className="toggle-height height-inherit">
            <div className="pro-create">
              <Row>
                <Col>
                  <div className="Wizard">
                    <ul className="list-inline d-flex justify-content-between mb-3 custom-width">
                      {steps.map((label, index) => (
                        <React.Fragment key={label}>
                          <li className={`list-inline-item me-0 ${activeStep === index ? 'active' : index < activeStep ? 'completed' : ''}`}
                            // onClick={() => {
                            //   if (index <= activeStep || validateCurrentStep()) {
                            //     setActiveStep(index);
                            //   } else {
                            //     toast.error('Please fill all mandatory fields before proceeding next.');
                            //   }
                            // }}
                            style={{ cursor: 'pointer' }}
                          >
                            {label}
                          </li>

                          {/* {index < steps.length - 1 && (  */}
                          <li className='w-100'>
                            <hr style={{ height: "2px", width: "100%" }} />
                          </li>
                          {/* )} */}

                        </React.Fragment>
                      ))}
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  {getContactContent(activeStep)}

                </Col>
              </Row>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactWizard;
